<template>
  <div>
    <app-top-navbar></app-top-navbar>
    <!-- <app-bottom-navbar></app-bottom-navbar> -->
    <slot></slot>
    <app-footer></app-footer>
  </div>
</template>

<script>
require('bootstrap')
import { LANDING_PAGE_DETAILS } from "../../../core/config/endpoints/general";
import { getCall } from "../../../core/services/http.service";
/* eslint-disable no-console */

import { AppTopNavbar, AppFooter } from "../../partials/default";
export default {
  name: "UserDefault",
  components: {
    AppTopNavbar,
    AppFooter,
  },

  data() {
    return {};
  },

  methods: {
    getLandingPageDetails() {
      getCall(LANDING_PAGE_DETAILS)
        .then(response => {
          let payload = {
            key: "landingPageDetails",
            value: response.data.data,
          };
          this.$store.commit("commitItem", payload);
        })
        .catch(error => {
          console.log(error);
        });
    },
  },

  computed: {
    landingPageDetails() {
      return this.$store.state.landingPageDetails;
    },
  },

  mounted() {
    if (!this.landingPageDetails) return this.getLandingPageDetails();
  },
};
</script>

<style>
.router-link-active,
.router-link,
.router-link-exact-active,
.clickable {
  cursor: pointer;
}
</style>
